import "core-js/modules/es.array.filter.js";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import _slicedToArray from "/home/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { InfoItem, When, colors } from '@aftersale-next/ui';
import { x } from '@xstyled/styled-components';
import { useTranslation } from 'react-i18next';
import { FaPen } from 'react-icons/fa';
import { useAppMode } from '../../hooks/use-app-mode';
import { useAvailableChannels } from '../../hooks/use-available-channels';
import { useNotificationActive } from '../../hooks/use-notification-active';
import { useNotificationChannel } from '../../hooks/use-notification-channel';
export var ChangeChannel = function ChangeChannel() {
  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var channel = useNotificationChannel();
  var availabelChannels = useAvailableChannels();
  var isNotificationActive = useNotificationActive();

  var _useAppMode = useAppMode(),
      _useAppMode2 = _slicedToArray(_useAppMode, 2),
      mode = _useAppMode2[0],
      setMode = _useAppMode2[1];

  var enabledChannels = availabelChannels.filter(function (ch) {
    return ch.enabled && ch.id !== (channel === null || channel === void 0 ? void 0 : channel.channel);
  });

  var selectChannel = function selectChannel(channel) {
    if (!enabledChannels && channel) return t('NOT_BE_NOTIFIED');
    if (!isNotificationActive) return t('NOT_BE_NOTIFIED');

    switch (channel) {
      case 'sms':
        return t('TEXT_MESSAGE');

      case 'whatsapp':
        return t('WHATSAPP');

      case 'email':
        return t('EMAIL');

      default:
        return t('SELECT_CHANNEL');
    }
  };

  var handleChangeChannel = function handleChangeChannel() {
    setMode('choose-channel');
  };

  return /*#__PURE__*/_jsxs(x.div, {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    spaceX: "4",
    color: "gray-600",
    onClick: handleChangeChannel,
    role: "button",
    "data-testid": "change-channel",
    children: [/*#__PURE__*/_jsx(InfoItem, {
      label: t('NOTIFICATION_CHANNEL'),
      value: selectChannel(channel !== null && channel !== void 0 && channel.channel ? channel.channel : '')
    }), /*#__PURE__*/_jsx(When, {
      value: mode !== 'choose-channel',
      children: /*#__PURE__*/_jsx(EditButton, {})
    })]
  });
};

function EditButton() {
  var _useTranslation2 = useTranslation(),
      t = _useTranslation2.t;

  return /*#__PURE__*/_jsx(x.button, {
    color: colors.inputColor,
    title: t('EDIT'),
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    w: "40px",
    h: "40px",
    borderRadius: "50%",
    borderWidth: "2px",
    background: 'transparent',
    borderColor: colors.inputColor,
    hoverBackground: colors.inputColor,
    hoverColor: "white",
    transitionDuration: "150ms",
    focusOutline: "none",
    children: /*#__PURE__*/_jsx(FaPen, {})
  });
}